export const EDITOR_TOOLS = [
  { id: 'basics', label: 'Basics', icon: 'fa-fill-drip' },
  { id: 'text', label: 'Text', icon: 'fa-bold' },
  { id: 'shapes', label: 'Shapes', icon: 'fa-shapes' },
  { id: 'buttons', label: 'Buttons', icon: 'fa-square' },
  { id: 'stickers', label: 'Stickers', icon: 'fa-heart' },
  { id: 'googleMap', label: 'Google Map', icon: 'fa-map-location-dot' },
];

export const FONT_LIST = [
  'Open Sans', 'Lato', 'Oswald', 'Arvo', 'Vollkorn', 'Droid Sans', 'Droid Serif',
  'Permanent Marker', 'Vibur', 'Abril Fatface', 'Amiri', 'Rubik One', 'Bevan',
  'Bungee Shade', 'Molle', 'Russo One', 'Space Mono', 'Indie Flower',
];

export const BUTTON_ACTIONS = [
  { id: 'link', label: 'Link (URL)' },
  { id: 'phone', label: 'Phone' },
  { id: 'senderphone', label: 'Sender Phone' },
  { id: 'directions', label: 'Directions' },
  { id: 'sendtemplateonreply', label: 'Send Template on Reply' },
  { id: 'sendtemplateon911', label: 'Send Template on 911' },
];

export const ROADSIDE_CHARGE_ACTIONS = [
  { id: 'roadside_regular_tow', label: 'Regular Tow', defaultAmount: 79 },
  { id: 'roadside_accident_tow', label: 'Accident Tow', defaultAmount: 99 },
  { id: 'roadside_boost', label: 'Boost', defaultAmount: 29 },
  { id: 'roadside_tire_service', label: 'Tire Service', defaultAmount: 39 },
  { id: 'roadside_lockout', label: 'Lockout Service', defaultAmount: 49 },
  { id: 'roadside_gas_delivery', label: 'Gas Delivery', defaultAmount: 34 },
];

export const ROADSIDE_ACTION_IDS = new Set(ROADSIDE_CHARGE_ACTIONS.map((a) => a.id));

export function getRoadsideDefaultAmount(actionId) {
  return ROADSIDE_CHARGE_ACTIONS.find((a) => a.id === actionId)?.defaultAmount ?? '';
}

export function isRoadsideChargeAction(actionId) {
  return ROADSIDE_ACTION_IDS.has(actionId);
}

export const SHAPE_CATALOG = [
  { id: 'circle', label: 'Circle', button: false },
  { id: 'rect', label: 'Rectangle', button: false },
  { id: 'triangle', label: 'Triangle', button: false },
  { id: 'editable', label: 'Editable Text', button: false },
  { id: 'entryfield', label: 'Entry Field', button: false },
  { id: 'orgbanner', label: 'Org Banner', button: false },
];

export const BUTTON_SHAPES = [
  { id: 'circle', label: 'Circle' },
  { id: 'rect', label: 'Rectangle' },
];

export const MAX_BUTTONS = 10;

export const PUBLIC_PIXIE = `${process.env.PUBLIC_URL || ''}/pixie`;
